/** Default lang. */
export const DEFAULT_LANG = 'fr';

/** Default country. */
export const DEFAULT_COUNTRY_CODE = 'fr';

/** JSON data file names. */
export const DataFiles = {
    BRANDS: 'stellantis_rappel_202503_marques.json',
    TRANSLATIONS: 'stellantis_rappel_202503_traductions.json',
    COUNTRIES: 'stellantis_rappel_202503_pays.json',
    LANGS: 'stellantis_rappel_202503_langues.json',
};
export type DataFiles = string;
